module.exports = __webpack_public_path__ + "static/media/lapsi.ed30ebcd.ogg";